import TextStyle from '../../../../../styles/text';

export default {
    titleStyle: {
        display: 'block',
        padding: '30px 30px 40px 30px',
        fontSize: '18px',
        color: '#000000',
        fontWeight: 500,
    },
    bodyStyle: {
        ...TextStyle.text_md,
        paddingLeft: '30px',
        paddingRight: '30px',
    },

    footerStyle: {
        paddingRight: '30px',
        paddingBottom: '20px',
    },
};
